<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="800px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ $t('Tvirtinimas el. spaudu') }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 py-4">
          <v-card-text>
            <h5>{{ $t('Kai pasirašysite dokumentą el. parašu, ar norėsite tvirtinti el. spaudu?') }}</h5>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button
          color="danger"
          @click.native="cancel()"
          :loading="loading"
          title="Ne"
        />
        <el-button
          color="primary"
          @click.native.stop="submit()"
          :loading="loading"
          title="Taip"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalStampRequired',
  props: {
    value: Boolean,
    loading: Boolean,
  },
  data() {
    return {}
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {},
  methods: {
    submit() {
      this.$emit('stampRequired')
      this.closeModal()
    },
    cancel() {
      this.$emit('stampNotRequired')
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
